import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import ReactCrop from "react-image-crop";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";

import * as theme from "../theme";
import { toast } from "react-toastify";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Select from "react-dropdown-select";
import {
  getDefaultInsurersList,
  getDefaultInsurersListSelector,
  getInsurerLogos,
  getLogoList,
} from "../store/brokerage";
import {
  getInsurerDetails,
  getSelectedInsurerDetails
} from "../store/insurers"
import _ from "lodash";

import { saveLogo } from "../store/insurers";
import { useNavigate, useSearchParams } from "react-router-dom";

const InsurerAdminLogo = (props) => {
  const dispatch = useDispatch();
  let insContacts = useSelector(getDefaultInsurersListSelector);
  const [cleanedContacts, setCleanedContacts] = useState();
  let logoList = useSelector(getLogoList);
  // console.log(logoList);
  const navigate = useNavigate()
  const [insurer, setInsurer] = useState(null);
  const [selectedCode, setSelectedCode] = useState(null);
  const [dbLogo, setDbLogo] = useState(null);
  let [searchParams, setSearchParams] = useSearchParams();
  const SelectedInsurerDetails = useSelector(getSelectedInsurerDetails);
  useEffect(() => {
    dispatch(getDefaultInsurersList());
    dispatch(getInsurerLogos());
  }, [dispatch]);
  console.log("searchParams: ", searchParams)
  const queryCode = searchParams.get('c');

  useEffect(async () => {
    await onChangeHandle([{code:queryCode}])
    console.log(SelectedInsurerDetails)
    console.log(insContacts)
  }, [queryCode])

  useEffect(() => {
    if (!_.isEmpty(insContacts)) {
      const tempContacts = insContacts.filter(
        (obj) => obj.hasOwnProperty("code") && obj.hasOwnProperty("name")
      );

      setCleanedContacts(tempContacts);
    }
  }, [insContacts]);

  const onChangeHandle = async (value) => {
    setSelectedCode(value[0].code);
    await dispatch(getInsurerDetails(value[0].code));
    navigate(
      "/quoteyadmin/logoandcolor?c=" + encodeURIComponent(value[0].code)
    );
    // console.log(logoList[value[0].code]);
    if (logoList[value[0].code]) {
      let db_img_val = "data:image/png;base64," + logoList[value[0].code];
      if(logoList[value[0].code].includes('http')){
        db_img_val = logoList[value[0].code]
      }
      setDbLogo(db_img_val);
    } 
    else {
      setDbLogo(null);
    }
  };
  useEffect(() => {
    if (SelectedInsurerDetails && SelectedInsurerDetails?.s3image?.Location){
      setDbLogo(SelectedInsurerDetails.s3image.Location)
    }
  }, [SelectedInsurerDetails]);

  return (
    <div>
      <div
        style={{
          width: "100%",
        }}
      >
        <div style={{ width: "80%", marginLeft: "10%", marginTop: "20px" }}>
          <Select
            placeholder={SelectedInsurerDetails ? SelectedInsurerDetails.name :"Search for an insurer"}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[]}
            options={cleanedContacts}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div>
      </div>
      <Logo insurerCode={selectedCode} dbLogo={dbLogo} setDbLogo={setDbLogo} />
    </div>
  );
};

const Logo = (props) => {
  const dispatch = useDispatch();
  const [upImg, setUpImg] = useState();
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [imgCheckboxText, setimgCheckboxText] = useState("Crop Image");
  const [imgCheckbox, setimgCheckbox] = useState(false);
  const [crop, setCrop] = useState({
    unit: "px",
    width: 352,
    height: 143,
  });

  function fileUploadhandler(canvas, crop) {
    var b64 = canvas.toDataURL("image");
    let data = {
      insurerCode: props.insurerCode,
      logo: b64,
    };
    dispatch(saveLogo(data));
    props.setDbLogo(b64);
  }

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    if (imgCheckbox) {
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
      setimgCheckboxText("Crop Image");
    } else {
      setimgCheckboxText("Fit to Size");
      canvas.width = 352;
      canvas.height = 143;
      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;

      var ratioX = canvas.width / image.naturalWidth;
      var ratioY = canvas.height / image.naturalHeight;
      var ratio = Math.min(ratioX, ratioY);
      ctx.drawImage(
        image,
        0,
        0,
        image.naturalWidth * ratio,
        image.naturalHeight * ratio
      );
    }
  }, [completedCrop, imgCheckbox]);

  const checkselectfile = (files) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => setUpImg(reader.result));
    reader.readAsDataURL(files[0]);
  };

  const dropzoneStyle = {
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  };

  return (
    <div className="container" style={{ padding: "10px" }}>
      <div className="row p-3">
        <div className="col-2">
          <p className="font-weight-bold">Add Logo</p>
        </div>
        <div className="col">
          {props.insurerCode ? (
            <div>
              <Dropzone
                onDrop={(files) => checkselectfile(files)}
                accept="image/*"
                multiple={false}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <p style={dropzoneStyle}>
                        Drag 'n' drop some files here, or click to select files
                      </p>
                    </div>
                  </section>
                )}
              </Dropzone>
            </div>
          ) : (
            "Select an Insurer to Upload Logo"
          )}
          <br />
          <div>
            <ReactCrop
              src={upImg}
              onImageLoaded={onLoad}
              crop={crop}
              locked={true}
              onChange={(c) => setCrop(c)}
              onComplete={(c) => setCompletedCrop(c)}
            />

            <br />
            <Form.Check
              inline
              label={imgCheckboxText}
              name="group1"
              type="checkbox"
              id={`inline-checkbox-1`}
              onClick={(e) => {
                setimgCheckbox(e.target.checked);
              }}
            />
            <p>Image Preview</p>
            <div>
              <canvas
                ref={previewCanvasRef}
                // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                style={{
                  width: Math.round(completedCrop?.width ?? 0),
                  height: Math.round(completedCrop?.height ?? 0),
                }}
              />
            </div>
          </div>
        </div>
        <div className="col">
          <Button
            style={{
              display: "flex",
              width: "100%",
              height: "100%",
              maxHeight: "6vmin",
              backgroundColor: theme.COLORS.secondary_skyblue,
              borderRadius: 5,
              color: "white",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "GibsonRegular",
              fontSize: "min(0.8vw, 15px)",
              letterSpacing: 1,
              border: 0,
            }}
            disabled={!completedCrop?.width || !completedCrop?.height}
            onClick={() =>
              fileUploadhandler(previewCanvasRef.current, completedCrop)
            }
          >
            {" "}
            Upload{" "}
          </Button>
        </div>
      </div>
      <div className="row p-3">
        <div className="col-2">
          <p className="font-weight-bold">Current Logo</p>
        </div>
        <div className="col-5"></div>
        <div className="col">
          {props.dbLogo ? (
            <img src={props.dbLogo} alt="current logo" />
          ) : (
            <p>No Logo Saved.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default InsurerAdminLogo;
